/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/ban-ts-comment */
import * as React from 'react';
import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import IconButton from '@mui/material/IconButton';
//@ts-ignore
import { HugeiconsIcon } from '@hugeicons/react';
//@ts-ignore
import {MultiplicationSignStrokeStandard} from '@hugeicons-pro/core-stroke-standard';

import './MUIModal.css'
const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialogContent-root': {
        padding: theme.spacing(0),
    }
    
}));

interface ModalProps {
    closeModal: () => void;
    openModal: boolean;
    children?: React.ReactNode;
    title?: string;
    width?: string | undefined;
}

const MUIModal: React.FC<ModalProps> = (props: ModalProps) => {
    // const [open, setOpen] = React.useState(false);
    const { closeModal, openModal, children, title, width } = props

    // const handleClickOpen = () => {
    //     setOpen(true);
    // };
    const handleClose = (): void => {
        // setOpen(false);
        closeModal()
    };

    return (
        <React.Fragment>
            <BootstrapDialog
                // onClose={handleClose}
                aria-labelledby="customized-dialog-title"
                className='mui-modal'
                open={openModal}
                PaperProps={{
                    sx: {
                        position: 'absolute',
                        top: '0',
                        right: '0',
                        maxWidth: '100%',
                        maxHeight: '100%',
                        transform: 'translate3d(0%, 0, 0)',
                        width: { lg: `${width !== undefined ? width : '50%'}` , md: '100%' },
                        height: '100%',
                        margin: 0,
                        borderRadius: 0
                        // bgcolor: 'background.paper',
                        // border: '2px solid #000',
                        // boxShadow: 24,
                        // p: 4,
                    },
                }}
            >
                <DialogTitle sx={{ m: 0, color: '#4D5E71', fontSize: '18px', fontWeight: '600', p: 0 }} id="customized-dialog-title">
                    <div className='grid grid-cols-1'>
                        <div className='modalTitle'>{title}</div>
                    </div>
                </DialogTitle>


                <IconButton
                    aria-label="close"
                    onClick={handleClose}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 6,
                        fontSize: '2rem',
                        color: (theme) => theme.palette.grey[500],
                        // "&:hover": { color: "#D6242C", background: 'transparent' }
                    }}
                >
                    
                    <HugeiconsIcon
                                     icon={MultiplicationSignStrokeStandard}
                                     size={'2rem'}
                                     color="currentcolor"
                                     strokeWidth={0.5}
                                   /> 
                </IconButton>
                <DialogContent>
                    {children}
                </DialogContent>
                {/* <DialogActions>
                    <Button autoFocus onClick={handleClose}>
                        Save changes
                    </Button>
                </DialogActions> */}
            </BootstrapDialog>
        </React.Fragment>
    );
}

export default MUIModal;